'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ShopSearch
 * @classdesc 店舗検索
 */
export default class ShopSearch {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--shop-search
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ShopSearch
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		const prefectureId = $('[name=prefecture_id]').val() || null;
		const city = $('[name=city]').val() || null;
		const keyword = $('[name=keyword]').val() || null;
		let prefix = '?';
		let params = '';
		if(!prefectureId && !city && !keyword) {
			Common.showErrorModal('都道府県かキーワードのどちらかは入力してください。');
			return;
		}
		if(prefectureId){
			params += `${prefix}prefecture_id=${prefectureId}`;
			prefix = '&';
		}
		if(city){
			params += `${prefix}city=${city}`;
			prefix = '&';
		}
		if(keyword) params += `${prefix}keyword=${keyword}`;
		const url = Common.getCurrentURL() + params;
		location.href = url;
	};
};
